import React from "react";

const DocsCard = ({
  size,
  data,
  hasAdditionalDocs = false,
  additionalDocs = [],
  editable = false,
  onEdit = (v) => v,
}) => {
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  return (
    <div className={`card redesigned_profile_card mx-0 ${(size && size) || ""}`}>
      <div className="card-header border-0">
        <div className="d-flex align-items-center">
          <img
            src={imagepaths.cardGaurdIcon}
            alt="cardGaurdIcon"
            className="card_icon"
            width="22"
            height="22"
          />
          <h5 className="title ms-2 mb-0">Docs Details</h5>
        </div>
        {editable && (
          <button
            type="button"
            className="btn edit_btn"
            onClick={(e) => onEdit(e)}
          >
            <i className="fa fa-pencil"></i>
          </button>
        )}
      </div>
      <div className="card-body">
        <div className="docs_grid">
          <div className="doc_item">
            <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
            <div className="doc_info">
              <span className="doc_title">PAN Card Front</span>
              {data?.panFileId ? (
                <a
                  href={`${BASE_URL}${data?.panFileId}`}
                  className="download_link"
                >
                  Download
                </a>
              ) : (
                <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
              )}
            </div>
          </div>

          <div className="doc_item">
            <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
            <div className="doc_info">
              <span className="doc_title">Aadhar Card (Front)</span>
              {data?.aadharFrontFileId ? (
                <a
                  href={`${BASE_URL}${data?.aadharFrontFileId}`}
                  className="download_link"
                >
                  Download
                </a>
              ) : (
                <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
              )}
            </div>
          </div>

          <div className="doc_item">
            <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
            <div className="doc_info">
              <span className="doc_title">Aadhar Card (Back)</span>
              {data?.aadharBackFileId ? (
                <a
                  href={`${BASE_URL}${data?.aadharBackFileId}`}
                  className="download_link"
                >
                  Download
                </a>
              ) : (
                <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
              )}
            </div>
          </div>

          <div className="doc_item border-0">
            <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
            <div className="doc_info">
              <span className="doc_title">Photo</span>
              {data?.photoFileId ? (
                <a
                  href={`${BASE_URL}${data?.photoFileId}`}
                  className="download_link"
                >
                  Download
                </a>
              ) : (
                <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
              )}
            </div>
          </div>

          {hasAdditionalDocs &&
            additionalDocs.map((doc, i) => {
              return (
                <div className="doc_item border-0" key={i}>
                  <img src={imagepaths.docsCardRedIcon} alt="docsCardRedIcon" />
                  <div className="doc_info">
                    <span className="doc_title">{doc?.fileName}</span>
                    {doc?.fileId ? (
                      <a
                        href={`${BASE_URL}${doc?.fileId}`}
                        className="download_link"
                      >
                        Download
                      </a>
                    ) : (
                      <span className="download_link text-muted" style={{ textDecoration: 'none', cursor: 'default' }}>No Document</span>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default constore(DocsCard);

